module.exports = __webpack_public_path__ + "img/Engagement & Wedding.e18cc42c.png";